import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import PUBLIC from "@/data/gatePublic.json";
import { API_BASE } from "@/lib/apiBase";

const KEY = "tt-journey-v1";
const EVT = "tt-journey-change";
export const REMINDER_KEY = "tt-reminder-v1";
const API = API_BASE;

export const readReminder = () => {
  try {
    return JSON.parse(localStorage.getItem(REMINDER_KEY) || "null");
  } catch {
    return null;
  }
};

export const currentGate = (d) => {
  for (let i = 0; i < 13; i += 1) if (gateProgress(d?.[i]) < 3) return i;
  return 12;
};

const syncReminderGate = (d) => {
  const r = readReminder();
  if (!API || !r?.client_token) return;
  axios.post(`${API}/reminders/gate`, { token: r.client_token, gate: currentGate(d) }).catch(() => {});
};

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return v && typeof v === "object" ? v : {};
  } catch {
    return {};
  }
};

export const readJourney = read;

export const getWeeks = (i) =>
  (PUBLIC.gates[i]?.weeks ?? []).map((w) => ({ ...w, name: w.title.replace(/^Week \d+:\s*/, "") }));

export const gateProgress = (entry) => (Array.isArray(entry?.weeks) ? entry.weeks.filter(Boolean).length : 0);

export const useJourney = () => {
  const [data, setData] = useState(read);
  useEffect(() => {
    const sync = () => setData(read());
    window.addEventListener("storage", sync);
    window.addEventListener(EVT, sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener(EVT, sync);
    };
  }, []);

  const save = useCallback((fn) => {
    const next = fn(read());
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVT));
    syncReminderGate(next);
  }, []);

  const toggleWeek = useCallback(
    (gate, w) =>
      save((d) => {
        const e = d[gate] ?? { weeks: [null, null, null], note: "" };
        const weeks = [...(e.weeks ?? [null, null, null])];
        weeks[w] = weeks[w] ? null : new Date().toISOString();
        return { ...d, [gate]: { ...e, weeks } };
      }),
    [save]
  );

  const setNote = useCallback(
    (gate, note) => save((d) => ({ ...d, [gate]: { weeks: [null, null, null], ...d[gate], note } })),
    [save]
  );

  const reset = useCallback(() => save(() => ({})), [save]);

  return { data, toggleWeek, setNote, reset };
};
